import { ActionContext, Module } from "vuex";
import { RootState } from "@/store/index";
import {Pallet, palletApi} from "@/api/pallet";

export interface PalletState {
  pallets: Pallet[];

}

const palletModule: Module<PalletState, RootState> = {
  namespaced: true,
  state: () =>
    ({
      pallets: [] as Pallet[],
    } as PalletState),
  mutations: {
    setAllPallets(state: PalletState, pallets: Pallet[]) {
      state.pallets = pallets;
    },
  },
  actions: {
    async listAll(context: ActionContext<PalletState, RootState>) {
      if (!context.state.pallets || context.state.pallets.length === 0) {
        context.commit("setAllPallets", await palletApi.list());
      }
    },
    async addPallet(
      context: ActionContext<PalletState, RootState>,
      pallet: Pallet
    ) {
      pallet.id = await palletApi.add(pallet);
      context.commit("setAllPallets", await palletApi.list());
    },
    async editPallet(
      context: ActionContext<PalletState, RootState>,
      pallet: Pallet
    ) {
      if (pallet.id) {
        await palletApi.edit(pallet);
        context.commit("setAllPallets", await palletApi.list());
      }
    },
    async removePallet(
      context: ActionContext<PalletState, RootState>,
      pallet: Pallet
    ) {
      if (pallet.id) {
        await palletApi.delete(pallet);
        context.commit("setAllPallets", await palletApi.list());
      }
    },
  },
};

export default palletModule;
